import {
  createContext, ReactElement, ReactNode, useContext, useEffect, useState,
} from 'react';
import { usePaymentToken } from '../services/payment/payment.queries';
import { Token } from '../models/payment.types';

type Props = {
    children: ReactNode
}

type ContextValue = {
    token: Token | undefined
};

const PaymentContext = createContext<ContextValue | null>(null);

export function PaymentProvider({ children }: Props): ReactElement {
  const [token, setToken] = useState<Token>();
  const { data: currentToken } = usePaymentToken();

  useEffect(() => {
    if (currentToken) {
      setToken(currentToken);
    }
  }, [currentToken]);

  const contextValue: ContextValue = {
    token,
  };

  return (
    <PaymentContext.Provider value={contextValue}>
      {children}
    </PaymentContext.Provider>
  );
}

export function usePayment() {
  const context = useContext(PaymentContext);
  if (!context) throw new Error('usePayment must be used within PaymentContext');
  return context;
}
